import {
    type View,
    Platform
} from "react-native";

export type PointerRect = {
    height: number;
    width: number;
    pageX: number;
    pageY: number;
};

const measurePointerRect = (node: View | null, onMeasure: (rect: PointerRect) => void) => {
    if(!node) {
        return;
    }

    const element = node as unknown as HTMLElement;

    if(Platform.OS === "web" && typeof element.getBoundingClientRect === "function") {
        const rect = element.getBoundingClientRect();

        onMeasure({
            height: rect.height,
            width: rect.width,
            pageX: rect.left,
            pageY: rect.top
        });

        return;
    }

    node.measure((_x, _y, width, height, pageX, pageY) => {
        onMeasure({
            height,
            width,
            pageX,
            pageY
        });
    });
};
export default measurePointerRect;
